export const getValidBudget = (value: string) => {
  return Math.abs(Number(value.replace(/^0+(?=\d)/,''))).toString()
}